import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiApps } from '@lumapps/lumx/icons';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { userDirectories } from '../../routes';

export interface UserDirectoriesSideNavigationProps extends Partial<SideNavigationItemProps> {
    /** Whether the nav item should render — gated by feature flag + permission upstream. */
    isAllowed?: boolean;
}

const UserDirectoriesSideNavigation = (props: UserDirectoriesSideNavigationProps) => {
    const { isAllowed = true, ...restOfProps } = props;
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            route={userDirectories()}
            label={translateKey(GLOBAL.USER_DIRECTORIES)}
            icon={mdiApps}
        />
    );
};

UserDirectoriesSideNavigation.displayName = 'SideNavigationItem';

export { UserDirectoriesSideNavigation };
